import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzInputModule } from 'ng-zorro-antd/input';
import { SaveAndCancelButtonsComponent } from '../buttons/save-and-cancel-buttons/save-and-cancel-buttons.component';
import { MarkdownItPipe } from '../pipes/markdown-it.pipe';

@Component({
  selector: 'app-text-popup',
  templateUrl: './text-popup.component.html',
  styleUrls: ['./text-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormsModule,
    NzFormModule,
    ReactiveFormsModule,
    NzGridModule,
    NzInputModule,
    SaveAndCancelButtonsComponent,
    MarkdownItPipe,
  ],
})
export class TextPopupComponent {
  validateForm!: UntypedFormGroup;

  @Input() title: string = '';
  @Input() descriptionMarkdown: string = '';

  @Output() cancel = new EventEmitter();

  @Input() placeHolder?: string = '';
  @Input() text?: string;
  @Output() save = new EventEmitter<string>();

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      text: [this.text, [Validators.required]],
    });
  }

  onCancelClick() {
    console.log('cancel');
    this.cancel.emit();
  }

  onSaveClick() {
    this.save.emit(this.validateForm.get('text')?.value);
  }
}
